'use strict';

import _ from 'underscore';
import $ from 'jquery';
import * as SingleBuyingOptionsService from '../../services/SingleBuyingOptionsService';
import * as globalisation from '../../utilities/globalisation';
import {SBO_ERRORS} from '../SingleBuyingOptions/SingleBuyingOptionConstants';
import ProductQuantityFormModal from './ProductQuantityFormModal';

// Version of the ProductQuantityFormModal that uses SingleBuyingOptions
export default class ProductSingleBuyingOptionsQuantityFormModal extends ProductQuantityFormModal {
  /**
   * Add the validation method for the quantity.
   */
  addBuyingOptionQuantityValidatorMethods() {
    super.addBuyingOptionQuantityValidatorMethods();
    $.validator.addMethod('singleBuyingOptionQuantity', this.validateSingleBuyingOptions.bind(this));
  }

  /**
   * Validate the quantity for single buying options.
   *
   * @param {number} quantity
   * @param {HTMLElement} element
   * @param {object} params
   * @returns {boolean}
   */
  validateSingleBuyingOptions(quantity, element, params) {
    let results = SingleBuyingOptionsService.getQuantitiesForBuyingOptions(this.modalData.model, quantity);

    if (!results.errors.length) {
      params.validatedBuyingOptions = _.map(results.quantities, (quantity, sourcePartId) => {
        return this.generateValidatedBuyingOption(quantity, sourcePartId, this.modalData.model.getBuyingOption(sourcePartId)
          .get('sourceCode'));
      });

      return true;
    }

    // Set the error message that will be used
    params.error = this._getFriendlyErrorMessages(results.errors).join('<br>');
    return false;
  }

  /**
   * Turn the error codes in to friendly error messages.
   *
   * @param {object[]} errors
   * @param {SingleBuyingOptionsModel} model
   * @returns {string[]}
   */
  _getFriendlyErrorMessages(errors) {
    var errorList = _.map(errors, error => {
      let { sourcePartId, type } = error;

      if (!sourcePartId || !type) {
        return globalisation.pluraliseAndTranslate('shoppingCart', SBO_ERRORS.INVALID_QUANTITY);
      }
      return globalisation.pluraliseAndTranslate('shoppingCart', type);
    });
    return _.uniq(errorList);
  }

  _getValidatorConfig() {
    let validtorConfig = super._getValidatorConfig();
    validtorConfig.messages.quantity.singleBuyingOptionQuantity = params => params.error;
    return validtorConfig;
  }

  addQuantityValidator() {
    // Add the correct type of quantity validation
    let quantityValidation = this.modalData.buyingOption ? 'buyingOptionQuantity' : 'singleBuyingOptionQuantity';
    this.$quantity.rules('add', { [quantityValidation]: this.modalData });
  }
}



// WEBPACK FOOTER //
// ./assets/components/ProductQuantityFormModal/ProductSingleBuyingOptionsQuantityFormModal.js